import { crossBackLace, mixBackLace, straightBackLace } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/lace/backLace'
import { ragdelionEngravedOfBackFace, ragdelionLabel } from 'src/features/brands/ragdelion/canvas/labels/ragdelion'
import { Brand, Position, State } from 'src/types'
import {
  crossBackLace as crossBackLaceOfFront,
  straightBackLace as straightBackLaceOfFront
} from 'src/features/brands/ragdelion/canvas/glove/rightThrow/front/lace/backLace'
import { outfielderDefaultBackLace } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/lace/outfielderDefaultBackLace'
import { outfielderDefaultBackLaceForFront } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/front/lace/outfielderDefaultBackLace'

export const backLaceDrawerOfFront = (ctx: CanvasRenderingContext2D, backLaceValue: string, laceColor: string, position: Position): void => {
  switch (backLaceValue) {
    case 'straight':
      straightBackLaceOfFront(ctx, laceColor, 0, 0, 1)
      straightBackLaceOfFront(ctx, laceColor, 128, -270, 30)
      straightBackLaceOfFront(ctx, laceColor, 222, -260, 30)
      return
    case 'crossAndStraight':
      crossBackLaceOfFront(ctx, laceColor, 5, 0, 1)
      straightBackLaceOfFront(ctx, laceColor, 128, -270, 30)
      straightBackLaceOfFront(ctx, laceColor, 222, -260, 30)
      return
    case 'cross':
      crossBackLaceOfFront(ctx, laceColor, 5, 0, 1)
      crossBackLaceOfFront(ctx, laceColor, 128, -270, 30)
      crossBackLaceOfFront(ctx, laceColor, 225, -265, 30)
      return
    default:
      switch (position) {
        case 'outfielder':
          crossBackLaceOfFront(ctx, laceColor, 5, -15, 1)
          outfielderDefaultBackLaceForFront(ctx, laceColor, 0, 20, 0)
          return
        default:
          return
      }
  }
}

export const backLaceDrawer = (ctx: CanvasRenderingContext2D, backLaceValue: string, laceColor: string, position: Position): void => {
  switch (backLaceValue) {
    case 'straight':
      straightBackLace(ctx, laceColor)
      return
    case 'crossAndStraight':
      mixBackLace(ctx, laceColor)
      return
    case 'cross':
      crossBackLace(ctx, laceColor)
      return
    default:
      switch (position) {
        case 'outfielder':
          outfielderDefaultBackLace(ctx, laceColor)
          return
        default:
          return
      }
  }
}

export const ragdelionLabelDrawerForGlove = (ctx: CanvasRenderingContext2D, state: State): void => {
  const labelPosition = state.labelPosition.value
  if (state.baseModel.position === 'pitcher') {
    if (state.baseModel.backStyle === 'firstBackStyle') {
      ragdelionLabel(ctx, state.ragLabel.value, 100, 110, -10, 0.85)
      return
    }
    // beltBackStyle or crownBackStyle👇
    ragdelionLabel(ctx, state.ragLabel.value, -180, 280, -30, 0.85)
    return
  }
  switch (labelPosition) {
    case 'thumbSide':
      ragdelionLabel(ctx, state.ragLabel.value, 90, -70, 0, 1)
      break
    case 'littleSide':
      ragdelionLabel(ctx, state.ragLabel.value, -40, 35, 0, 0.8)
      break
    case 'onBelt':
      ragdelionLabel(ctx, state.ragLabel.value, 0, 0, 0, 1)
      break
    case 'byThumb':
      ragdelionLabel(ctx, state.ragLabel.value, -170, 235, -35, 0.9)
      ragdelionEngravedOfBackFace(ctx, state.catchFace.value, 0, 0)
      break
    default:
      break
  }
}

export const ragdelionLabelDrawerForGloveLeftThrow = (ctx: CanvasRenderingContext2D, state: State): void => {
  const labelPosition = state.labelPosition.value
  if (state.baseModel.position === 'pitcher') {
    if (state.baseModel.backStyle === 'firstBackStyle') {
      ragdelionLabel(ctx, state.ragLabel.value, 200, -405, 42, 0.85)
      return
    }
    // beltBackStyle or crownBackStyle👇
    ragdelionLabel(ctx, state.ragLabel.value, 250, -480, 50, 0.9)
    return
  }

  switch (labelPosition) {
    case 'thumbSide':
      ragdelionLabel(ctx, state.ragLabel.value, 90, -70, 0, 1)
      break
    case 'littleSide':
      ragdelionLabel(ctx, state.ragLabel.value, -40, 35, 0, 0.8)
      break
    case 'onBelt':
      ragdelionLabel(ctx, state.ragLabel.value, 40, 0, 0, 1)
      break
    case 'byThumb':
      ragdelionLabel(ctx, state.ragLabel.value, 210, -520, 55, 0.82)
      ragdelionEngravedOfBackFace(ctx, state.catchFace.value, 45, 0)
      break
    default:
      break
  }
}

export const ragdelionLabelDrawerForCatcherMitt = (ctx: CanvasRenderingContext2D, state: State): void => {
  if (state.baseModel.backStyle === 'beltBackStyle') {
    if (state.labelPosition.value === 'byThumb') {
      ragdelionEngravedOfBackFace(ctx, state.catchFace.value, 10, 125, 0.9)
      return ragdelionLabel(ctx, state.ragLabel.value, 100, 100, -10, 0.87)
    }
    if (state.labelPosition.value === 'onBelt') {
      return ragdelionLabel(ctx, state.ragLabel.value, -15, 105, 0, 0.92)
    }
  }
  if (state.baseModel.backStyle === 'regularBackStyle') {
    return ragdelionLabel(ctx, state.ragLabel.value, 100, 100, -10, 0.87)
  }
}

export const ragdelionLabelDrawerForCatcherMittLeftThrow = (ctx: CanvasRenderingContext2D, state: State): void => {
  if (state.baseModel.backStyle === 'beltBackStyle') {
    if (state.labelPosition.value === 'byThumb') {
      ragdelionEngravedOfBackFace(ctx, state.catchFace.value, 145, 125, 0.9)
      return ragdelionLabel(ctx, state.ragLabel.value, 270, -370, 40, 0.8)
    }
    if (state.labelPosition.value === 'onBelt') {
      return ragdelionLabel(ctx, state.ragLabel.value, 165, 157, 0, 0.85)
    }
  }
  if (state.baseModel.backStyle === 'regularBackStyle') {
    return ragdelionLabel(ctx, state.ragLabel.value, 55, -50, 10, 0.87)
  }
}
